var map = {
	"./fonts/asap/AsapCondensed-Bold.ttf": 2550,
	"./fonts/asap/AsapCondensed-BoldItalic.ttf": 900,
	"./fonts/asap/AsapCondensed-Italic.ttf": 1355,
	"./fonts/asap/AsapCondensed-Medium.ttf": 2173,
	"./fonts/asap/AsapCondensed-MediumItalic.ttf": 1299,
	"./fonts/asap/AsapCondensed-Regular.ttf": 6227,
	"./fonts/asap/AsapCondensed-SemiBold.ttf": 8387,
	"./fonts/asap/AsapCondensed-SemiBoldItalic.ttf": 281,
	"./fonts/open-sans/OpenSans-Bold.ttf": 2155,
	"./fonts/open-sans/OpenSans-ExtraBold.ttf": 7243,
	"./fonts/open-sans/OpenSans-Regular.ttf": 5846,
	"./fonts/open-sans/OpenSans-Semibold.ttf": 4547,
	"./fonts/roboto/Roboto-Black.ttf": 4845,
	"./fonts/roboto/Roboto-BlackItalic.ttf": 4060,
	"./fonts/roboto/Roboto-Bold.ttf": 2171,
	"./fonts/roboto/Roboto-BoldItalic.ttf": 7992,
	"./fonts/roboto/Roboto-Italic.ttf": 8508,
	"./fonts/roboto/Roboto-Light.ttf": 4381,
	"./fonts/roboto/Roboto-LightItalic.ttf": 6634,
	"./fonts/roboto/Roboto-Medium.ttf": 9027,
	"./fonts/roboto/Roboto-MediumItalic.ttf": 9815,
	"./fonts/roboto/Roboto-Regular.ttf": 134,
	"./fonts/roboto/Roboto-Thin.ttf": 2781,
	"./fonts/roboto/Roboto-ThinItalic.ttf": 7783,
	"./icons/facebook-white.svg": 3141,
	"./icons/facebook.svg": 3902,
	"./icons/instagram-white.svg": 8724,
	"./icons/instagram.svg": 673,
	"./icons/no-image.png": 2379,
	"./icons/twitter-white.svg": 5362,
	"./icons/twitter.svg": 3961,
	"./images/banner-bricks.webp": 9351,
	"./images/banner-minecraft.webp": 6903,
	"./images/logo-bricks-king.png": 1985,
	"./images/logo-cleaning-idle.png": 7460,
	"./images/logo-mine.webp": 315,
	"./images/logo-prota-icon.png": 5197,
	"./images/logo-prota-secondary.png": 5251,
	"./images/logo-prota-white.png": 5257,
	"./images/logo-prota.png": 8732,
	"./images/logo-woodmill.png": 7826,
	"./images/mock-bricks-king.png": 6041,
	"./images/mock-cleaning-idle.png": 6591,
	"./images/mock-hom.png": 307,
	"./images/mock-mine.webp": 3959,
	"./images/mock-woodmill.png": 1788
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7173;